/**
 * Pick display text: use server-resolved descriptionDisplay when present, otherwise
 * pick from translatedDescriptions by preferred language.
 * @param {string} [descriptionDisplay] - Server-resolved text (from central translation cache)
 * @param {Array<{ translatedToLanguage: string, translatedText: string }>} [translatedDescriptions]
 * @param {string} [sourceLanguage]
 * @param {string} [sourceText]
 * @param {string} [preferredLanguage] - e.g. user.languages.ui or "English"
 * @returns {string}
 */
export function getDisplayTextFromTranslations(
  translatedDescriptions,
  sourceLanguage,
  sourceText,
  preferredLanguage,
  descriptionDisplay
) {
  if (descriptionDisplay !== undefined && descriptionDisplay !== null && String(descriptionDisplay).trim() !== "") {
    return String(descriptionDisplay).trim();
  }
  const pref = (preferredLanguage || "English").trim();
  if (translatedDescriptions?.length) {
    const translation = translatedDescriptions.find(
      (t) => t.translatedToLanguage === pref
    );
    if (translation?.translatedText) return translation.translatedText;
  }
  const lang = (sourceLanguage || "").trim();
  const normalizedLang = lang.toLowerCase();
  if (lang && normalizedLang !== "unknown" && normalizedLang !== pref.toLowerCase()) {
    return `${sourceText || ""} [${lang.toUpperCase()}]`;
  }
  return sourceText || "";
}

/**
 * Prefer server-resolved *Display field when present, otherwise source field.
 * Use for project description, task title/description, etc. (not project name — always show as-is).
 * @param {object} item - Object that may have field and field + 'Display'
 * @param {string} field - Base field name (e.g. 'name', 'description', 'title')
 * @returns {string}
 */
export function displayText(item, field) {
  if (!item) return "";
  const display = item[field + "Display"];
  if (display !== undefined && display !== null && String(display).trim() !== "") {
    return String(display).trim();
  }
  const raw = item[field];
  return raw !== undefined && raw !== null ? String(raw) : "";
}
